import { Container } from "./style";

export const DashedLine = (props: any) => (
    <Container>
        <div className={props.className}></div>
    </Container>
);